module.exports = __webpack_public_path__ + "img/logo_drawing.f4cc0a59.svg";